import { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Tabs,
  Tab,
  Pagination,
  Dropdown,
  ButtonGroup,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import "./Content.css";
import {
  faCaretDown,
  faCaretUp,
  faPen,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import {
  ACADIMAC,
  baseURL,
  DELETACASEC,
  DELETEMONTY,
  STYDYMONTH,
} from "../../../API/API";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";
import { toast } from "react-toastify";

export default function StudyMonths() {
  const [activeTab, setActiveTab] = useState("published");
  const [chapters, setChapters] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [Order, setOrder] = useState("chapterName");
  const [OrderType, setOrderType] = useState(false);
  const [TypeStudent, setTypeStudent] = useState("-");
  const [post, setpost] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [bulkAction, setBulkAction] = useState("");
  const [showmessage, setShowMessage] = useState(false);
  const [rowId, setrowId] = useState([]);
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Academacs, setAcademacs] = useState([]);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const { refreshKey } = useDataRefresh();
  const fetchData = useCallback(async () => {
    try {
      const res = await axiosPrivate.post(`${baseURL}/${STYDYMONTH}`, {
          Order,
          OrderType,
          TypeStudent,
          post,
          indexpage,
      });
      setChapters(res.data.data);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      console.log(err);
      toast.error("خطأ في تحميل البيانات");
    }
  }, [axiosPrivate, Order, OrderType, TypeStudent, post, indexpage]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refreshKey]);

  useEffect(() => {
    async function fetchAcademics() {
      try {
        const res = await axiosPrivate.get(`${baseURL}/${ACADIMAC}`);
        if (res.data && res.data.data) {
          setAcademacs(res.data.data);
        }
      } catch (err) {
        console.error("خطأ في تحميل السنوات الدراسية:", err);
        toast.error("فشل تحميل السنوات الدراسية");
      }
    }

    fetchAcademics();
  }, [axiosPrivate]);

  async function deleteItems(selectedIds) {
    try {
      const res = await axiosPrivate.delete(`${baseURL}/${DELETEMONTY}`, {
        data: { ids: selectedIds },
      });
      toast.success("تم الحذف بنجاح");
      fetchData();
    } catch (err) {
      console.log(err);
      toast.error("فشل حذف العناصر");
    }
  }

  return (
    <>
      <div className="p-4 content" dir="rtl">
        <div className="d-flex align-items-center mb-5">
          <h4 className="fw-bold">الشهور الدراسية</h4>
        <Link
          to="/DashboardLayout/content/addmonth"
          style={{ textDecoration: "none" }}
        >
          <Button className="custom-brand-btn-dhash">إضافة</Button>
        </Link>
      </div>

      {/* Tabs */}
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => {
          setActiveTab(k);
          setpost(k === "drafts");
        }}
        className="mb-3"
        justify
      >
        <Tab eventKey="published" title="المنشورات" />
        <Tab eventKey="drafts" title="المسودات" />
      </Tabs>

      {/* Filters */}
      <div className="d-flex mb-3 gap-2 flex-wrap">
        <Form.Select
          style={{ maxWidth: "240px" }}
          onChange={(e) => setBulkAction(e.target.value)}
        >
          <option value="">تنفيذ على العناصر المحددة</option>
          <option value="delete">حذف</option>
        </Form.Select>

        <Button
          className="custom-brand-btn-dhash"
          variant="secondary"
          onClick={() => {
            if (selectedItems.length > 0) {
              setShowMessage(true);
            }
          }}
        >
          تطبيق
        </Button>

        <Dropdown dir="ltr" as={ButtonGroup}>
          <Dropdown.Toggle
            split
            variant="secondary"
            id="dropdown-split-basic"
            style={{
              backgroundColor: "var(--brand-200)",

              boxShadow: "0 3px 0px rgb(3, 42, 61)",
            }}
          />
          <Button
            className="custom-brand-btn-dhash"
            dir="ltr"
            variant="secondary"
          >
            السنة الدراسية
          </Button>
          <Dropdown.Menu>
            {Academacs.map((acd, index) => (
              <Dropdown.Item key={index} onClick={() => setTypeStudent(acd.id)}>
                {acd.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <Button
          onClick={() => {
            fetchData();
          }}
          className="custom-brand-btn-dhash"
          variant="outline-secondary"
        >
          فلتره
        </Button>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <Table striped bordered hover className="align-middle text-center">
          <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
            <tr>
              {/* UP and down */}
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span>الاسم</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "chapterName");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "chapterName");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <span>السنة الدراسية</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "academicYear");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "academicYear");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> عدد الدروس</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "lessonsCount");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "lessonsCount");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> سعر الشهر</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "chapterPrice");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "chapterPrice");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px", //1/ مسافة بين النص والأيقونات
                  }}
                >
                  <span> الترتيب</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px", //1/ اختياري: لتصغير الأيقونات
                      cursor: "pointer", //1/ لو هتخليها قابلة للضغط
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "order");
                        setOrderType(() => true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder(() => "order");
                        setOrderType(() => false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th>أدوات</th>

              <th>*</th>
            </tr>
          </thead>
          <tbody>
            {chapters.map((row, index) => (
              <tr key={index}>
                <td>{row.chapterName}</td>
                <td>{row.academicYear}</td>
                <td>{row.lessonsCount ?? row.lessons_count ?? 0}</td>
                <td>{row.chapterPrice ?? row.price ?? "—"}</td>
                <td>{row.order ?? row.sort_order ?? "—"}</td>
                <td className="d-flex justify-content-center gap-2">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>حذف</Tooltip>}
                  >
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => {
                        setrowId([row.id]);
                        setShowMessage(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </OverlayTrigger>

                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>تعديل</Tooltip>}
                  >
                    <Link
                      to="/DashboardLayout/content/updatemonth"
                      state={{ id: row.id }}
                    >
                      <Button size="sm" variant="outline-warning">
                        <FontAwesomeIcon
                          icon={faPen}
                          style={{ color: "#FFA500" }}
                        />
                      </Button>
                    </Link>
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip>عرض</Tooltip>}>
                    <Button
                      size="sm"
                      variant="outline-info"
                      onClick={() => {
                        setPreviewData(row);
                        setShowPreviewModal(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faEye} style={{ color: "#17A2B8" }} />
                    </Button>
                  </OverlayTrigger>
                </td>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedItems.includes(row.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedItems((prev) => [...prev, row.id]);
                      } else {
                        setSelectedItems((prev) =>
                          prev.filter((id) => id !== row.id)
                        );
                      }
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Pagination
        className="justify-content-center custom-pagination"
        dir="ltr"
      >
        <Pagination.Prev
          onClick={() => {
            if (indexpage > 1) setindexPage(indexpage - 1);
          }}
          disabled={indexpage === 1}
        />

        {[...Array(totalPages).keys()]
          .map((n) => n + 1)
          .filter(
            (page) =>
              page === 1 ||
              page === totalPages ||
              (page >= indexpage - 2 && page <= indexpage + 2)
          )
          .map((page, i, arr) => {
            const prevPage = arr[i - 1];
            if (prevPage && page - prevPage > 1) {
              return [
                <Pagination.Ellipsis key={`ellipsis-${page}`} disabled />,
                <Pagination.Item
                  key={page}
                  active={indexpage === page}
                  onClick={() => setindexPage(page)}
                >
                  {page}
                </Pagination.Item>,
              ];
            }

            return (
              <Pagination.Item
                key={page}
                active={indexpage === page}
                onClick={() => setindexPage(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

        <Pagination.Next
          onClick={() => {
            if (indexpage < totalPages) setindexPage(indexpage + 1);
          }}
          disabled={indexpage === totalPages}
        />
      </Pagination>

      {showPreviewModal && (
        <Modal
          show={showPreviewModal}
          onHide={() => setShowPreviewModal(false)}
          centered
          dir="ltr"
        >
          <Modal.Header className="position-relative border-0">
            <Modal.Title className="fw-bold fs-5">تفاصيل الشهر</Modal.Title>

            <Button
              variant="danger"
              onClick={() => setShowPreviewModal(false)}
              className="position-absolute top-0 end-0 me-3 mt-2 p-0 rounded-circle d-flex align-items-center justify-content-center"
              style={{
                width: "32px",
                height: "32px",
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              ×
            </Button>
          </Modal.Header>
          <Modal.Body>
            {previewData ? (
              <div style={{ direction: "rtl", lineHeight: "1.8" }}>
                <p>
                  <strong>الاسم: </strong> {previewData.chapterName}
                </p>
                <p>
                  <strong>السنة الدراسية: </strong> {previewData.academicYear}
                </p>
                <p>
                  <strong>عدد الدروس: </strong>{" "}
                  {previewData.lessonsCount ?? previewData.lessons_count ?? 0}
                </p>
                <p>
                  <strong>السعر: </strong>{" "}
                  {previewData.chapterPrice ?? previewData.price ?? "—"}
                </p>
                <p>
                  <strong>الترتيب: </strong>{" "}
                  {previewData.order ?? previewData.sort_order ?? "—"}
                </p>
              </div>
            ) : (
              <div className="text-center text-muted p-4">لا توجد بيانات</div>
            )}
          </Modal.Body>
        </Modal>
      )}

      {showmessage && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-content">
            <h2>
              <BsExclamationTriangleFill className="text-warning fs-1 me-2" />
              ستقوم بحذف العناصر المحددة
            </h2>
            <div>
              <p>لن تتمكن من التراجع عن هذا الإجراء.</p>
              <p></p>
            </div>

            <div className="d-flex justify-content-start gap-3 ">
              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  if (rowId.length > 0) {
                    deleteItems(rowId);
                    setrowId([]);
                  } else if (bulkAction === "delete" && selectedItems.length > 0) {
                    deleteItems(selectedItems);
                  }
                  setShowMessage(false);
                }}
              >
                تاكيد الحذف
              </button>

              <button
                className="btn btn-outline-danger mt-3"
                onClick={() => {
                  setShowMessage(false);
                }}
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      )}
      </div>
    </>
  );
}
